import axios from '@/plugin/axios';

const parseStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user')) || null;
  } catch (error) {
    return null;
  }
};

const getStoredAdminId = () => {
  const storedUser = parseStoredUser();

  return (
    storedUser?.id ||
    storedUser?.admin_id ||
    storedUser?.data?.id ||
    storedUser?.data?.admin_id ||
    storedUser?.user?.id ||
    null
  );
};

const getStoredOrganizationId = () => {
  const storedUser = parseStoredUser();

  return (
    storedUser?.organization_id ||
    storedUser?.organization?.id ||
    storedUser?.user?.organization_id ||
    storedUser?.data?.organization_id ||
    null
  );
};

const getCurrentProfile = () => axios.get('/auth/profile/');

const updateOrganizationLoginDetails = (payload) => {
  const organizationId = getStoredOrganizationId();

  if (!organizationId) {
    return Promise.reject(new Error('Unable to resolve current organization profile.'));
  }

  return axios.post(`/organizations/${organizationId}/login-details/`, payload);
};

export {
  getCurrentProfile,
  getStoredAdminId,
  getStoredOrganizationId,
  updateOrganizationLoginDetails,
};
